import React from 'react';
import SectionCard from './SectionCard';
import { Checkbox } from '../../../components/ui/checkbox';

const EmailInboxSection = ({ submission, isDark }) => {
    return (
        <SectionCard isDark={isDark}>
            <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`}>Add email address of Manager/Assist <span className='text-FF0000'>*</span></p>
            <div>
                <input
                    className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                        isDark
                            ? 'bg-[#161515]  text-white'
                            : 'bg-[#f5f5f5] text-[#072837]'
                    }`}
                    type="text"
                    value={submission.email || ''}
                    readOnly
                />
            </div>
            {submission.inbox_id && (
                <>
                    <div className={`p-[16px] w-full rounded-[8px] border-none flex flex-col gap-[12px] transition-colors duration-200 ${
                        isDark ? 'bg-[#161515] ' : 'bg-[#f5f5f5] '
                    }`}>
                        <p className={`m-0 text-[14px] font-semibold transition-colors duration-200 ${
                            isDark ? 'text-white' : 'text-[#072837]'
                        }`}>Select Inbox - If no inbox is selected, default channel will be used</p>
                        <div className='flex items-center gap-[8px]'>
                            <Checkbox id="inbox-selected" checked={true} labelClassName="cursor-default" isDark={isDark}  />
                            <span className={`text-[14px] text-capitalize transition-colors duration-200 ${
                                isDark ? 'text-white' : 'text-[#072837]'
                            }`}>{submission.inbox_name}</span>
                        </div>

                        {submission.inbox_id && submission.channel_id && (
                            <div className="flex flex-col gap-[8px]">
                                <p className={`m-0 text-[14px] font-semibold transition-colors duration-200 ${
                                    isDark ? 'text-white' : 'text-[#072837]'
                                }`}>Select Email</p>
                                <input
                                    className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                                        isDark 
                                            ? 'bg-[#161515]  text-white' 
                                            : 'bg-white  text-[#072837]'
                                    }`}
                                    type="text"
                                    name="channel_id"
                                    value={submission.channel_send_as}
                                    readOnly
                                />
                            </div>
                        )}
                    </div>
                </>
            )}

            {!submission.inbox_id && submission.channel_id && (
                <>
                    <div className={`px-[16px] w-full rounded-[8px] border-none transition-colors duration-200 ${
                        isDark ? 'bg-[#161515] ' : 'bg-[#f5f5f5] '
                    }`}>
                        <div className="py-[16px]">
                            <div className="flex flex-col gap-[8px]">
                                <p className={`m-0 text-[14px] font-semibold transition-colors duration-200 ${
                                    isDark ? 'text-white' : 'text-[#072837]'
                                }`}>Select Email</p>
                                <input
                                    className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                                        isDark
                                            ? 'bg-[#000000]  text-white'
                                            : 'bg-white  text-[#072837]'
                                    }`}
                                    type="text"
                                    name="channel_id"
                                    value={submission.channel_send_as}
                                    readOnly
                                />
                                </div>
                        </div>
                    </div>
                </>
            )}

            <div className={`text-[12px] transition-colors duration-200 ${
                isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
            }`}>A confirmation email will be sent once issued.</div>
        </SectionCard>
    );
};

export default EmailInboxSection;
